import config from "../config";

const shouldLog = () => config.runmode && config.runmode.debug;

const logger = {
  log: (...args) => {
    if (!shouldLog()) return;
    console.log(...args);
  },
  info: (...args) => {
    if (!shouldLog()) return;
    console.info(...args);
  },
  warn: (...args) => {
    if (!shouldLog()) return;
    console.warn(...args);
  },
  error: (...args) => {
    if (!shouldLog()) return;
    console.error(...args);
  },
  debug: (...args) => {
    if (!shouldLog()) return;
    console.debug(...args);
  },
};

export default logger;
